import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";
import theme from "../../theme";
import CommonButton from "../button";

// Accessible confirm dialog (MUI Dialog traps focus + handles Escape/keyboard).
// Used for destructive actions; keeps the action button busy while loading.
function ConfirmDialog({
  open,
  title = "Are you sure?",
  description,
  confirmText = "Confirm",
  cancelText = "Cancel",
  danger = true,
  loading = false,
  onConfirm,
  onClose,
}) {
  return (
    <Dialog
      open={!!open}
      onClose={loading ? undefined : onClose}
      aria-labelledby="confirm-dialog-title"
      aria-describedby="confirm-dialog-description"
      PaperProps={{ style: { borderRadius: "15px", padding: "8px 12px", maxWidth: "440px" } }}
    >
      <DialogTitle id="confirm-dialog-title">
        <span
          style={{
            color: theme.colors.Violet,
            fontFamily: theme.fontFamily.MARKPROBOLD,
            fontSize: "20px",
          }}
        >
          {title}
        </span>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="confirm-dialog-description">
          <span
            style={{
              color: theme.colors.Violet,
              fontFamily: theme.fontFamily.MARKPROBOOK,
              fontSize: "15px",
            }}
          >
            {description}
          </span>
        </DialogContentText>
      </DialogContent>
      <DialogActions style={{ padding: "8px 24px 20px" }}>
        <div style={{ width: "110px", marginRight: "12px" }}>
          <CommonButton
            type="button"
            text={cancelText}
            stylevariant="secondary2"
            fontSize="14px"
            disabled={loading}
            onClick={onClose}
          />
        </div>
        <div style={{ width: "130px" }}>
          <CommonButton
            type="button"
            text={confirmText}
            stylevariant={danger ? "danger" : "primary"}
            fontSize="14px"
            loading={loading}
            disabled={loading}
            onClick={onConfirm}
          />
        </div>
      </DialogActions>
    </Dialog>
  );
}

export default ConfirmDialog;
